import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFile,
  faQuestionCircle,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { faInfoCircle } from '@whitebox-learning/fontawesome-pro-duotone-svg-icons';
import { GAME_PAGE_INTRO } from '../../constants/game';
import LevelProgress from './LevelProgress';

export default function LevelInfo({
  game,
  level,
  levelUp,
  setGameView,
  gotoDesignChallenge,
  compName,
}) {
  return (
    <>
      <LevelProgress game={game} levelUp={levelUp} setGameView={setGameView} />

      <div className="mb-3">
        {game.canLevelUp ? (
          <>
            <div className="alert alert-success">
              <Alert.Heading>
                Congratulations! You've qualified for the next level!
              </Alert.Heading>
              <p>
                Once you move to the next level, you{' '}
                <strong>can't go back</strong> until you reach the final level.
                If you want to keep working on your designs for level{' '}
                {level.level}, you can wait to level up or come back later.
              </p>
              <p>
                Remember: When you move to the next level, the iterations and
                performance component scores will reset to zero. You'll need to
                make a new design that meets the next level's specifications to
                earn points. Your grades score component will not be changed.
              </p>
              <div className="text-center">
                <Button onClick={levelUp} size="lg" variant="success">
                  Ready? Click Here to Level Up!
                </Button>
              </div>
            </div>
          </>
        ) : (
          <div className="border rounded p-3">
            <div className="d-flex align-items-start">
              <FontAwesomeIcon icon={faInfoCircle} className="mt-3 fs-2" />
              <div className="bg-white p-3 rounded">
                <h4>Design Challenge</h4>

                <div>
                  <p className="fs-6">
                    Remember that the <strong>design challenge</strong> changes
                    for each level. Be sure to check the specifications each
                    time you move to a new level.
                  </p>
                  <Button size="md" variant="wb" onClick={gotoDesignChallenge}>
                    <FontAwesomeIcon icon={faFile} /> &nbsp;Go to{' '}
                    <b>Level {level.level}</b> Design Challenge!
                  </Button>

                  <Button
                    size="sm"
                    variant="link"
                    className="ms-2 text-decoration-none"
                    onClick={() => setGameView(GAME_PAGE_INTRO)}
                  >
                    <FontAwesomeIcon icon={faQuestionCircle} className="me-1" />
                    About {compName}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
